import { useQuery } from "@tanstack/react-query";
import { getTotalTVL } from "services";
import { useIdle } from "react-use";
const useTotalTVL = () => {
  const isIdle = useIdle(150e3);

  // const { data: tvlStats, isLoading } = useQuery({
  //   queryKey: ["tvlStats"],
  //   queryFn: async () => {
  //     const r = await getTVL();
  //     return r.data;
  //   },
  // });

  // const { data: gainTvl, isLoading: isLoadingGainTvl } = useQuery({
  //   queryKey: ["gainTvl"],
  //   queryFn: async () => {
  //     const r = await getGainTVL();
  //     return r.data;
  //   },
  // });

  // const stakedAmount = useMemo(() => {
  //   let amount = 0;
  //   if (tvlStats?.usdTvl) {
  //     amount += tvlStats.usdTvl;
  //   }
  //   if (gainTvl) {
  //     amount += gainTvl.tvl;
  //   }
  //   return amount;
  // }, [tvlStats, gainTvl]);

  const { data: totalTvl, isLoading } = useQuery({
    queryKey: ["totalTvl"],
    queryFn: async () => {
      const r = await getTotalTVL();
      return r.data;
    },
    enabled: !isIdle,
    staleTime: 20_000,
    refetchInterval: 20_000,
  });

  return {
    isLoadingTotalTvl: isLoading,
    totalStaked: totalTvl?.tvl,
  };
};

export default useTotalTVL;
